import LanguageActionTypes from './types'

export const LanguageActionCreators = {
  changeLanguage: (language, langKey) => ({
    type: LanguageActionTypes.CHANGE_LANGUAGE,
    language,
    langKey,
  }),
}
